import {FilterTable} from "../filter-table/filter-table";
import {columns} from "../../models/property/property-table-columns";
import {useEffect, useState} from "react";
import {setTitle} from "../../helpers/helper";
import {PaginatedResponse} from "../../models/paginated-response/paginated-response";
import {Property} from "../../models/property/property";
import {useSearchParams} from "react-router-dom";
import {UrlService} from "../../services/url";
import {Filter} from "../../models/filter-table/filter-table";

const filterFields: Filter[] = [
    {
        type: "input",
        name: "Street",
        placeholder: "Please fill street name",
        fieldKey: "street",
        selectValues: null,
        operands: [
            {name: "Like", value: "like"},
            {name: "=", value: "equal"},
            {name: "!=", value: "not equal"},
        ]
    },
    {
        type: "input",
        name: "House number",
        placeholder: "Please fill house number",
        fieldKey: "houseNumber",
        selectValues: null,
        operands: []
    },
    {
        type: "input",
        name: "Kadaster number",
        placeholder: "Please fill kadaster number",
        fieldKey: "kadasterNumber",
        selectValues: null,
        operands: [
            {name: "Like", value: "like"},
            {name: "=", value: "equal"},
            {name: "!=", value: "not equal"},
        ]
    },
]

export const PropertyList: React.FC = () => {
    const [searchParams] = useSearchParams();

    const p = (searchParams.get("page") !== null ? parseInt(searchParams.get("page") as string) : 1);
    const op = (searchParams.get("onPage") !== null ? parseInt(searchParams.get("onPage") as string) : 10);
    const url = new UrlService();
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(true);
    const [tableData, setTableData] = useState<PaginatedResponse<Property> | null>(null);
    const [page, setPage] = useState<number>(p);
    const [viewOnPage, setViewOnPage] = useState<number>(10);
    const [filter, setFilter] = useState<string>((searchParams.get("filter") !== null ? searchParams.get("filter") as string : ""));

    useEffect(() => {
        getProperty();
    }, [viewOnPage, page, filter]);

    useEffect(() => {
        if (p !== page) {
            setPage(p)
        }
        if (op !== viewOnPage) {
            setViewOnPage(op)
        }
    }, [p, op]);

    const updateFilter = (filter: string) => {
        console.log("Updated filter", filter)
        setFilter(filter);
        setPage(1);
    }

    const changeViewOnPage = (e: React.FormEvent<HTMLSelectElement>) => {
        let rowsCount: number = parseInt(e.currentTarget.value);
        url.updateSearchParams([["page", page + ""], ["onPage", rowsCount + ""]])
        setViewOnPage(rowsCount)
    }

    const changePage = (e: any) => {
        let page: number = parseInt(e.currentTarget.getAttribute("custom-attr"));
        url.updateSearchParams([["page", page + ""], ["onPage", viewOnPage + ""]])
        setPage(page);
    }

    const getProperty = async () => {

        setError(false);
        setLoading(true);

        console.log("Filter", filter)

        try {
            const response = await fetch("/api/v1/private/property/paginated?page=" + page + "&onPage=" + viewOnPage + (filter !== "" ? "&filter=" + filter : ""));
            console.log(response.url)
            if (!response.ok) {
                setError(true);
                return;
            }

            const responseData = await response.json();
            console.log(responseData);
            setTableData(responseData);
            setLoading(false);
            setError(false);
            setTitle("Property list")

        } catch (e) {
            console.log(e);
        }
    }

    return (
        <>
            <h2>Property</h2>
            <FilterTable loading={loading} error={error} filters={filterFields} data={tableData} columns={columns}
                         setPage={changePage} setViewOnPage={changeViewOnPage} recallData={(filter: string) => {
                updateFilter(filter)
            }}/>
        </>
    );
}